import { render, staticRenderFns } from "./register-card.vue?vue&type=template&id=b72cb3ec&scoped=true"
import script from "./register-card.vue?vue&type=script&lang=js"
export * from "./register-card.vue?vue&type=script&lang=js"
import style0 from "./register-card.vue?vue&type=style&index=0&id=b72cb3ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72cb3ec",
  null
  
)

export default component.exports